<template>
    <div id="full-screen-button" ref="fullButton" :class="fullScreenButton">
        <div v-if="token" class="full-text off-line">
            <div class="offline" @click="offline">退出投屏</div>
        </div>
        <div class="full-text" @click="fullScreen">
            <div v-if="fullscreen" class="full-screen">取消全屏</div>
            <div v-else="" class="full-screen">全屏</div>
        </div>
        <div class="fold">
            <div :class="fold ? 'open' : 'close'" @click="foldTo"></div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['reload'],
    data: function() {
        return {
            fullscreen: false,
            fullScreenButton: 'full-screen-button',
            fold: false,
            token: sessionStorage.getItem('__token'),
        };
    },

    watch: {
        fullscreenState(val){
            this.fullscreen = !val;
        },
        token(val) {
            console.log(val);
            if (val) {
                this.fold = true;
                this.$refs.fullButton.style.transform = 'translateX(-250px)';
            } else {
                this.fold = false;
                this.$refs.fullButton.style.transform = 'translateX(0)';
            }
        }
    },

    created: function() {
        window.addEventListener('setItem', ()=> {
            this.token = sessionStorage.getItem('__token');
            console.log(sessionStorage.getItem('__token'));
        });
        let doc = window.document;
        doc.addEventListener('fullscreenchange', () => {
            if (!document.fullscreen) {
                this.fullscreen = false;
            }
        });
        
    },
    mounted: function() {
    },
    
    
    methods: {
        foldTo:function(){
            this.fold = !this.fold;
            if(this.token){
                if (this.fold) {
                    this.$refs.fullButton.style.transform = 'translateX(-250px)';
                } else {
                    this.$refs.fullButton.style.transform = 'translateX(0)';
                }
            }else{
                if(this.fold){
                    this.$refs.fullButton.style.transform = 'translateX(-125px)';
                }else{
                    this.$refs.fullButton.style.transform = 'translateX(0)';
                }
            }
            
        },
        fullScreen: function() {
            let element = document.documentElement;
            if(this.fullscreen) {
                if(document.exitFullscreen) {
                    document.exitFullscreen();
                } else if(document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if(document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if(document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if(element.requestFullscreen) {
                    element.requestFullscreen();
                } else if(element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if(element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if(element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
                // this.fullscreen = true;
            }
            this.fullscreen = !this.fullscreen;
        },
        
        offline: function() {
            location.href = "";
            sessionStorage.clear();
            this.token = sessionStorage.getItem('__token');
            this.$router.push({path:'/'});
            
        }
    }
};
</script>

<style>
    .full-screen-button {
        position: fixed;
        bottom: 100px;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 0 100px 100px 0;
        z-index: 999;
    }
    
    .full-screen-button1 {
        position: fixed;
        bottom: 50px;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000;
        border-radius:  100px 0 0 100px ;
        flex-direction: row-reverse;
    }

    .full-screen-button1 > div{
        color: #FFFFFF;
        display: flex;
        justify-content:center;
        align-items: center;
        font-size: 18px;
    }
    
    .full-screen-button > div {
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
    }

    .offline {
        background: url(../assets/image/closefull.png);
        background-size: 20px 20px;
        background-position: left center;
        background-repeat: no-repeat;
        padding-left: 25px;
        font-size: 18px;
    }

    .offline:hover {
        background-image: url(../assets/image/closefullhover.png);
        color: #4A7FB5;
    }
    
    .full-screen {
        background: url(../assets/image/fullscreen.png) no-repeat;
        background-position-y: 50%;
        background-size: 20px 20px;
        font-size: 18px;
        padding-left: 25px;
    }
    
    .full-screen:hover{
        background: url(../assets/image/fullscreen-hover.png) no-repeat;
        background-position-y: 50%;
        background-size: 20px 20px;
        color: #4A7FB5;
    }

    .full-text {
        width: 125px;
        height: 60px;
        line-height: 60px;
        vertical-align: middle;
    }

    .full-img {
        width: 20px;
        height: 20px;
        background: url(../assets/image/fullscreen.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 5px;
    }

    .off-img {
        width: 20px;
        height: 20px;
        background: url(../assets/image/closefull.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 5px;
    }
    
    .fold {
        width: 40px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
    }
    
    .fold > div {
        width: 20px;
        height: 20px;
    }

    .open {
        background: url(../assets/image/open.png) no-repeat;
        background-size: 100% 100%;
    }
    .open:hover {
        background: url(../assets/image/openhover.png) no-repeat;
        background-size: 100% 100%;
    }

    .close {
        background: url(../assets/image/close.png) no-repeat;
        background-size: 20px 20px;
    }

    .close:hover {
        background: url(../assets/image/closehover.png) no-repeat;
        background-size: 20px 20px;
    }

</style>